import React, { useState, useEffect } from 'react';
import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';
import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';

const token    = window.location.pathname.split('/verify/')[1];
const BASE_URL = '';

Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId:     'ap-south-1:0e2fa510-8e72-4c20-8fce-3e3485437165',
      identityPoolRegion: 'ap-south-1',
      allowGuestAccess:   true,
    }
  },
  aws_cognito_identity_pool_id: 'ap-south-1:0e2fa510-8e72-4c20-8fce-3e3485437165',
  aws_cognito_region:           'ap-south-1',
  aws_project_region:           'ap-south-1',
  accountId:                    '405539348291',
});

export default function App() {
  const [sessionId, setSessionId] = useState(null);
  const [status, setStatus]       = useState('loading');
  const [errorMsg, setErrorMsg]   = useState('');

  useEffect(() => { createSession(); }, []);

  async function createSession() {
    try {
      const res  = await fetch('/api/verification/liveness-web/session', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ token })
      });
      const data = await res.json();
      if (data.success) {
        setSessionId(data.data.sessionId);
        setStatus('ready');
      } else {
        setErrorMsg(data.message || 'Failed to create session');
        setStatus('error');
      }
    } catch (e) {
      setErrorMsg(e.message);
      setStatus('error');
    }
  }

  async function handleComplete() {
    console.log('✅ Liveness complete! Token:', token, 'SessionId:', sessionId);
    setStatus('verifying');
    try {
      const res = await fetch('/api/verification/liveness-web/complete', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ token, sessionId })
      });
      console.log('📡 Response status:', res.status);
      const data = await res.json();
      console.log('📡 Response data:', data);
      if (data.success) {
        setStatus('success');
      } else {
        setErrorMsg(data.message || 'Verification failed');
        setStatus('error');
      }
    } catch (e) {
      console.error('❌ Complete error:', e.message);
      setErrorMsg(e.message);
      setStatus('error');
    }
  }

  function handleError(err) {
    // err is { state: LivenessErrorState, error: Error } — log both for diagnosis
    console.error('❌ FaceLiveness onError:', {
      state:   err?.state,
      message: err?.error?.message || err?.message,
      raw:     err,
    });
    const msg = err?.error?.message || err?.message || 'Face liveness failed. Please try again.';
    setErrorMsg(`${err?.state ? `[${err.state}] ` : ''}${msg}`);
    setStatus('error');
  }

  const card = {
    fontFamily:     '-apple-system, sans-serif',
    background:     'white',
    borderRadius:   '24px',
    padding:        '32px 24px',
    maxWidth:       '420px',
    width:          '100%',
    boxShadow:      '0 24px 64px rgba(0,0,0,0.2)',
    textAlign:      'center',
  };

  return (
    <div style={{ background:'linear-gradient(135deg,#ec4899,#a855f7)', minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px' }}>
      <div style={card}>
        <div style={{ fontSize:28, fontWeight:'bold', color:'#ec4899', marginBottom:4 }}>💕 DearSoulmate</div>
        <div style={{ color:'#999', fontSize:13, marginBottom:24 }}>Find Your Perfect Match</div>

        {status === 'loading' && (
          <>
            <div style={{ fontSize:48, marginBottom:12 }}>⏳</div>
            <div style={{ fontSize:18, fontWeight:'bold', color:'#1a1a2e' }}>Preparing verification...</div>
          </>
        )}

        {status === 'ready' && sessionId && (
          <>
            <div style={{ fontSize:18, fontWeight:'bold', color:'#1a1a2e', marginBottom:8 }}>Face Verification</div>
            <div style={{ color:'#666', fontSize:14, marginBottom:16 }}>Follow the on-screen instructions to verify your identity.</div>
            <FaceLivenessDetector
              sessionId={sessionId}
              region="ap-south-1"
              onAnalysisComplete={handleComplete}
              onError={handleError}
            />
          </>
        )}

        {status === 'verifying' && (
          <>
            <div style={{ fontSize:48, marginBottom:12 }}>⏳</div>
            <div style={{ fontSize:18, fontWeight:'bold', color:'#1a1a2e' }}>Verifying your identity...</div>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize:64, marginBottom:16 }}>✅</div>
            <div style={{ fontSize:22, fontWeight:'bold', color:'#1a1a2e', marginBottom:8 }}>Identity Verified!</div>
            <div style={{ color:'#666', fontSize:14, marginBottom:20 }}>You now have a verified badge on your profile.</div>
            <div style={{ background:'linear-gradient(135deg,#ec4899,#a855f7)', color:'white', padding:'10px 24px', borderRadius:'25px', display:'inline-block', fontWeight:'bold' }}>✨ Verified Member</div>
            <p style={{ color:'#999', fontSize:13, marginTop:16 }}>Go back to the app to continue 💕</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize:48, marginBottom:16 }}>❌</div>
            <div style={{ fontSize:20, fontWeight:'bold', color:'#1a1a2e', marginBottom:8 }}>Verification Failed</div>
            <div style={{ color:'#666', fontSize:14, marginBottom:20 }}>{errorMsg}</div>
            <button onClick={() => { setStatus('loading'); setErrorMsg(''); createSession(); }}
              style={{ background:'linear-gradient(135deg,#ec4899,#a855f7)', color:'white', border:'none', padding:'14px 32px', borderRadius:'30px', fontSize:'16px', fontWeight:'bold', cursor:'pointer', width:'100%' }}>
              🔄 Try Again
            </button>
          </>
        )}
      </div>
    </div>
  );
}
